// import React, { useEffect, useState } from "react";
// import "../assets/transactions/SavingTransactionForm.css";
// import Select from "react-select";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import axios from "axios";
// import { toast } from "react-toastify";

// const API_URL = "https://payyug.in/api";

// const RDDDAccountTransaction = () => {
//   const dispatch = useDispatch();
//   const { profile } = useSelector((state) => state.userProfile);

//   const [accounts, setAccounts] = useState([]);
//   const [selectedAccount, setSelectedAccount] = useState(null);
//   const [uploadedKyc, setUploadedKyc] = useState([]);
//   const [showPreview, setShowPreview] = useState(false);
//   const [bankDetails, setBankDetails] = useState({
//     bankName: "",
//     bankBranch: "",
//     bankIfsc: "",
//     bankAccount: "",
//   });

//   const [formData, setFormData] = useState({
//     amount: "",
//     transactionType: "",
//     paymentMode: "CASH",
//     transactionDate: "",
//     narration: "",
//   });

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   //    const fetchAccounts = async () => {
//   //       try {
//   //         const res = await axios.get(`${API_URL}/get-all-saving-account`, {
//   //           params: {
//   //             superAdminId: profile.superAdminId || 14,
//   //             branchId: profile.branchId || 8,
//   //             createdBy: localStorage.getItem("userId"),
//   //           },
//   //         });
//   //         setAccounts(res.data?.accounts || []);
//   //       } catch (err) {
//   //         toast.error(err?.response?.data?.message || "Failed to fetch accounts");
//   //       }
//   //     };

//   const fetchAccounts = async () => {
//     try {
//       // setLoading(true);
//       const superAdminId = profile.superAdminId || 14;
//       const branchId = localStorage.getItem("userId") || 56;

//       const res = await axios.get("https://payyug.in/api/deposit/list", {
//         params: {
//           superAdminId,
//           branchId,
//           // status: activeSecondary !== "All" ? activeSecondary : undefined,
//           // search: searchQuery || undefined,
//         },
//       });

//       //   console.log("deposit list:",res)
//       if (res.data.success) {
//         setAccounts(res.data.data || []);
//       } else {
//         setAccounts([]);
//       }
//     } catch (err) {
//       console.error("Error fetching deposit accounts:", err);
//       setAccounts([]);
//     } finally {
//       //setLoading(false);
//     }
//   };

//   // fetch Customer for selected Account
//   const fetchCustomerDetails = async () => {
//     if (!selectedAccount) return;

//     try {
//       const res = await axios.get(
//         "https://payyug.in/api/customers-get-userId",
//         {
//           params: {
//             userId: selectedAccount?.customerId,
//             superAdminId: profile?.superAdminId,
//           },
//         },
//       );

//       if (res.data.data) {
//         const r = res.data.data;

//         // Handle different response structures safely
//         setBankDetails({
//           bankName: r.bankName,
//           bankAccount: r.bankAccount,
//           bankIfsc: r.bankIFSC,
//           bankBranch: r.bankBranch,
//         });
//       }
//     } catch (err) {
//       toast.error(
//         err?.response?.data?.message || "Error fetching referral details",
//       );
//       setBankDetails({
//         bankName: "",
//         bankAccount: "",
//         bankIfsc: "",
//         bankBranch: "",
//       });
//     }
//   };

//   useEffect(() => {
//     if (profile) fetchAccounts();
//     if (selectedAccount) fetchCustomerDetails();
//   }, [profile, selectedAccount]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   /* ================= CALCULATE CHARGES ================= */
//   const calculateNetWithdrawal = () => {
//     const amount = Number(formData.amount);

//     // 1. Ensure we have data
//     if (!selectedAccount) {
//       return {
//         net: amount,
//         charge: 0,
//         isEarly: false,
//         lockinMonths: 6,
//         percentage: 0,
//       };
//     }

//     // 2. Extract values (with fallbacks)
//     const lockinMonths =
//       6 || Number(selectedAccount.scheme?.depositLockinPeriod) || 6;
//     const chargePercentage =
//       Number(selectedAccount.scheme?.closureChargeBeforeValue) || 0;

//     const openingDate = new Date(selectedAccount.openingDate);
//     const transactionDate = formData.transactionDate
//       ? new Date(formData.transactionDate)
//       : new Date();

//     const diffTime = Math.abs(transactionDate - openingDate);
//     const diffMonths = diffTime / (1000 * 60 * 60 * 24 * 30.44);

//     // 3. Logic for Warning
//     if (diffMonths < lockinMonths) {
//       const chargeAmount = (amount * chargePercentage) / 100;
//       return {
//         net: amount + chargeAmount, // Note: Withdrawal usually subtracts charge from payout
//         charge: chargeAmount,
//         percentage: chargePercentage,
//         isEarly: true,
//         lockinMonths,
//       };
//     }

//     return {
//       net: amount,
//       charge: 0,
//       isEarly: false,
//       lockinMonths,
//       percentage: chargePercentage,
//     };
//   };

//   // Use the helper in your component
//   const { net, charge, percentage, isEarly, lockinMonths } =
//     calculateNetWithdrawal();

//   const calculateMonthDifference = () => {
//     if (!selectedAccount?.openingDate) return 0;

//     const openingDate = new Date(selectedAccount.openingDate);
//     const transactionDate = new Date(); //treat it as current date.
//     // (formData.transactionDate);
//     // const currentDate = new Date(); // current date

//     const diffTime = transactionDate - openingDate;
//     const diffMonths = diffTime / (1000 * 60 * 60 * 24 * 30.44);

//     return diffMonths > 0 ? diffMonths.toFixed(1) : 0;
//   };

//   /* ================= VALIDATION & PREVIEW ================= */
//   const handlePreview = (e) => {
//     e.preventDefault();
//     if (!selectedAccount) return toast.warn("Please select saving account");
//     if (
//       !formData.amount ||
//       !formData.transactionType ||
//       !formData.transactionDate
//     ) {
//       return toast.warn("Please fill all required fields");
//     }
//     if (
//       formData.transactionType === "WITHDRAWAL" &&
//       Number(formData.amount) > Number(selectedAccount.totalDeposited)
//     ) {
//       return toast.warn("Withdrawal amount exceeds available balance");
//     }
//     setShowPreview(true);
//   };

//   /* ================= FINAL SUBMIT ================= */
//   const handleSubmit = async () => {
//     try {
//       const payload = {
//         accountId: selectedAccount.id,
//         withdrawAmount: Number(net),
//         // transactionType: formData.transactionType,
//         withdrawMode: formData.paymentMode,
//         // transactionDate: formData.transactionDate,
//         remarks: formData.narration,
//         // status: "Paid",
//         // employeeId: localStorage.getItem("userId"),
//         withdrawnBy: localStorage.getItem("userId"),
//       };

//       // const url = formData.transactionType === "DEPOSIT"
//       //   ? "/saving-account/bank/deposit"
//       //   : "/saving-account/bank/withdraw";
//       const url = "/deposit/pay/withdraw";

//       const res = await axios.post(`${API_URL}${url}`, payload);
//       toast.success(res?.data?.message || "Transaction successful");

//       setFormData({
//         amount: "",
//         transactionType: "",
//         paymentMode: "CASH",
//         transactionDate: "",
//         narration: "",
//       });
//       setSelectedAccount(null);
//       setShowPreview(false);
//       if (profile) fetchAccounts();
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Transaction failed");
//     }
//   };

//   useEffect(() => {
//     const fetchKyc = async () => {
//       if (selectedAccount?.customerId) {
//         try {
//           const res = await axios.get(`${API_URL}/list-kyc`, {
//             params: {
//               userId: selectedAccount.customerId,
//               createdId: profile.id,
//             },
//           });
//           setUploadedKyc(res.data.documents || []);
//         } catch {
//           setUploadedKyc([]);
//         }
//       }
//     };
//     fetchKyc();
//   }, [selectedAccount, profile?.id]);

//   return (
//     <div className="saving-account-transaction-container">
//       <h2>RD DD Transaction Portal</h2>
//       {/* <h2>RD DD Transaction Portal</h2> */}

//       <p
//         style={{
//           background: "#fff8e1",
//           color: "#8a6d3b",
//           padding: "10px",
//           borderRadius: "5px",
//           fontSize: "0.85rem",
//           marginBottom: "15px",
//           border: "1px solid #faebcc",
//         }}
//       >
//         ℹ️ Note: If the account is less than <strong>6 months old</strong>, an{" "}
//         <strong>early withdrawal charge</strong> will be applied as per scheme
//         rules.
//       </p>

//       <form
//         className="saving-account-transaction-payment-details"
//         onSubmit={handlePreview}
//       >
//         <h4>
//           <i className="fa-solid fa-shield-halved"></i> Payment Details
//         </h4>

//         <div className="payment-details-container">
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>RD/DD Account</label>
//               <Select
//                 className="account-select-container"
//                 classNamePrefix="account-select"
//                 placeholder="Search by Name or A/C No..."
//                 options={accounts.map((acc) => ({
//                   value: acc.id,
//                   label: `${acc.customerName} | ${acc.accountNo}`,
//                   account: acc,
//                 }))}
//                 value={
//                   selectedAccount
//                     ? {
//                         value: selectedAccount.id,
//                         label: `${selectedAccount.customerName} | ${selectedAccount.accountNo}`,
//                       }
//                     : null
//                 }
//                 onChange={(selected) => setSelectedAccount(selected?.account)}
//                 isSearchable
//               />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Available Balance</label>
//               <input
//                 type="text"
//                 value={`₹ ${selectedAccount?.totalDeposited || "0.00"}`}
//                 readOnly
//               />
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Amount (INR)</label>
//               <input
//                 type="number"
//                 name="amount"
//                 value={formData.amount}
//                 onChange={handleChange}
//                 placeholder="0.00"
//               />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Transaction Type</label>
//               <select
//                 name="transactionType"
//                 value={formData.transactionType}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Type</option>
//                 {/* <option value="DEPOSIT">DEPOSIT</option> */}
//                 <option value="WITHDRAWAL">WITHDRAWAL</option>
//               </select>
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Early Withdrawl Charge(%)</label>
//               <input type="text" value={`${percentage}%`} readOnly />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Penalty Amount</label>
//               <input
//                 type="text"
//                 value={`₹ ${Number(charge || 0).toFixed(2)}`}
//                 readOnly
//               />
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Account Opening Date</label>
//               <input
//                 type="text"
//                 value={
//                   selectedAccount?.openingDate
//                     ? new Date(selectedAccount.openingDate).toLocaleDateString(
//                         "en-IN",
//                       )
//                     : ""
//                 }
//                 readOnly
//               />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Account Tenure (Months)</label>
//               <input
//                 type="text"
//                 value={
//                   selectedAccount?.openingDate
//                     ? `${calculateMonthDifference()} months`
//                     : "0 months"
//                 }
//                 readOnly
//               />
//             </div>
//           </div>

//           {/* NEW DYNAMIC WARNING MESSAGE */}
//           {isEarly && formData.transactionType === "WITHDRAWAL" && (
//             <p
//               style={{
//                 color: "#c53030",
//                 fontSize: "0.75rem",
//                 marginTop: "5px",
//                 fontWeight: "600",
//                 lineHeight: "1.2",
//               }}
//             >
//               ⚠️ Warning: Account tenure is less than 6 months. A penalty of{" "}
//               {percentage}% (₹{charge.toFixed(2)}) will be applied.
//             </p>
//           )}
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Payment Mode</label>
//               <select
//                 name="paymentMode"
//                 value={formData.paymentMode}
//                 onChange={handleChange}
//               >
//                 <option value="CASH">CASH</option>
//                 <option value="UPI">UPI</option>
//                 <option value="RTGS">NEFT RTGS</option>
//               </select>
//             </div>
//             <div className="payment-details-inputs">
//               <label>Transaction Date</label>
//               <input
//                 type="date"
//                 name="transactionDate"
//                 value={formData.transactionDate}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>
//         </div>

//         <div className="payment-details-input-groups">
//           <div className="payment-details-inputs">
//             <label>Narration</label>
//             <input
//               type="text"
//               name="narration"
//               value={formData.narration}
//               onChange={handleChange}
//               placeholder="Optional narration"
//             />
//           </div>
//         </div>

//         <div className="kyc-section-title">Verified Documents</div>
//         <div className="kyc-cards-container">
//           {uploadedKyc.length === 0 ? (
//             <p className="no-kyc">No KYC documents found for this account</p>
//           ) : (
//             uploadedKyc.map((doc, index) => (
//               <div className="kyc-card" key={index}>
//                 <img
//                   src={`https://payyug.in/uploads/${doc.docImage}`}
//                   alt="KYC"
//                   className="kyc-image"
//                   onClick={() =>
//                     window.open(
//                       `https://payyug.in/uploads/${doc.docImage}`,
//                       "_blank",
//                     )
//                   }
//                 />
//                 <p className="doctitle">{doc.docName || "Document"}</p>
//               </div>
//             ))
//           )}
//         </div>

// {selectedAccount && (
//   <div className="bank-data-section">
//     <h3 className="bank-data-title">Bank Details</h3>
//     <div className="bank-data-grid">
//       <div className="bank-data-item">
//         <span className="bank-data-label">Account Number</span>
//         <span className="bank-data-value">{bankDetails?.bankAccount || "N/A"}</span>
//       </div>
//       <div className="bank-data-item">
//         <span className="bank-data-label">Bank Name</span>
//         <span className="bank-data-value">{bankDetails?.bankName || "N/A"}</span>
//       </div>
//       <div className="bank-data-item">
//         <span className="bank-data-label">IFSC Code</span>
//         <span className="bank-data-value">{bankDetails?.bankIfsc || "N/A"}</span>
//       </div>
//       <div className="bank-data-item">
//         <span className="bank-data-label">Branch</span>
//         <span className="bank-data-value">{bankDetails?.bankBranch || "N/A"}</span>
//       </div>
//     </div>
//   </div>
// )}

//         <div className="pay-btn">
//           <button type="submit">Verify & Process Transaction</button>
//         </div>
//       </form>

//       {/* ================= PREVIEW MODAL ================= */}
//       {/* {showPreview && (
//         <div className="modal-overlay">
//           <div className="transaction-modal">
//             <h3>Confirm Transaction</h3>
//             <div className="modal-content">
//               <div className="modal-row"><span>Account:</span> <strong>{selectedAccount.customerName}</strong></div>
//               <div className="modal-row"><span>A/C Number:</span> <strong>{selectedAccount.accountNo}</strong></div>
//               <div className="modal-row"><span>Type:</span> <strong className={formData.transactionType}>{formData.transactionType}</strong></div>
//               <div className="modal-row amount-row"><span>Amount:</span> <strong>₹ {formData.amount}</strong></div>
//             </div>
//             <div className="modal-actions">
//               <button className="cancel-btn" onClick={() => setShowPreview(false)}>Edit</button>
//               <button className="confirm-btn" onClick={handleSubmit}>Confirm Payment</button>
//             </div>
//           </div>
//         </div>
//       )} */}
//       {showPreview && (
//         <div className="modal-overlay">
//           <div className="transaction-modal">
//             <h3>Confirm Withdrawal</h3>
//             <div className="modal-content">
//               <div className="modal-row">
//                 <span>Account No:</span>{" "}
//                 <strong>{selectedAccount.accountNo}</strong>
//               </div>

//               {isEarly ? (
//                 <div
//                   className="early-warning-box"
//                   style={{
//                     background: "#fff5f5",
//                     padding: "10px",
//                     borderRadius: "5px",
//                     marginBottom: "10px",
//                     border: "1px solid #feb2b2",
//                   }}
//                 >
//                   <p
//                     style={{ color: "#c53030", margin: 0, fontSize: "0.85rem" }}
//                   >
//                     <strong>Early Withdrawal Warning:</strong> This account is
//                     within the {lockinMonths} month lock-in period.
//                   </p>
//                 </div>
//               ) : null}

//               <div className="modal-row">
//                 <span>Requested Amount:</span>{" "}
//                 <strong>₹ {formData.amount}</strong>
//               </div>

//               {isEarly && (
//                 <div className="modal-row" style={{ color: "#c53030" }}>
//                   <span>Penalty ({percentage}%):</span>
//                   <strong>- ₹ {charge.toFixed(2)}</strong>
//                 </div>
//               )}

//               <div
//                 className="modal-row amount-row"
//                 style={{
//                   borderTop: "2px solid #eee",
//                   marginTop: "10px",
//                   paddingTop: "10px",
//                 }}
//               >
//                 <span>Net Payout:</span>
//                 <strong style={{ color: "#2d3748", fontSize: "1.3rem" }}>
//                   ₹ {net.toFixed(2)}
//                 </strong>
//               </div>
//             </div>

//             <div className="modal-actions">
//               <button
//                 className="cancel-btn"
//                 onClick={() => setShowPreview(false)}
//               >
//                 Back to Edit
//               </button>
//               <button className="confirm-btn" onClick={handleSubmit}>
//                 Confirm & Withdraw
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RDDDAccountTransaction;



import React, { useEffect, useState } from "react";
import "../assets/transactions/SavingTransactionForm.css";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const RDDDAccountTransaction = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    bankBranch: "",
    bankIfsc: "",
    bankAccount: "",
  });

  const [formData, setFormData] = useState({
    amount: "",
    transactionType: "",
    paymentMode: "CASH",
    transactionDate: "",
    narration: "",
  });

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchAccounts = async () => {
    try {
      const superAdminId = profile?.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;

      const res = await axios.get("https://payyug.in/api/deposit/list", {
        params: {
          superAdminId,
          branchId,
        },
      });

      if (res?.data?.success) {
        setAccounts(res?.data?.data || []);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      console.error(err);
      setAccounts([]);
      toast.error("Failed to fetch accounts");
    }
  };

  const fetchCustomerDetails = async () => {
    if (!selectedAccount) return;

    try {
      const res = await axios.get(
        "https://payyug.in/api/customers-get-userId",
        {
          params: {
            userId: selectedAccount?.customerId,
            superAdminId: profile?.superAdminId,
          },
        },
      );

      const r = res?.data?.data;

      if (r) {
        setBankDetails({
          bankName: r?.bankName || "",
          bankAccount: r?.bankAccount || "",
          bankIfsc: r?.bankIFSC || "",
          bankBranch: r?.bankBranch || "",
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Error fetching customer details",
      );

      setBankDetails({
        bankName: "",
        bankAccount: "",
        bankIfsc: "",
        bankBranch: "",
      });
    }
  };

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchAccounts();
    }
  }, [profile]);

  useEffect(() => {
    if (selectedAccount) {
      fetchCustomerDetails();
    }
  }, [selectedAccount]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const calculateNetWithdrawal = () => {
    const amount = Number(formData.amount);

    if (!selectedAccount || !amount || amount <= 0) {
      return {
        net: 0,
        charge: 0,
        interest: 0,
        status: "INITIAL",
        percentage: 0,
        diffMonths: 0,
        ruleMessage: "Enter amount and select account",
        lockinMonths: 6,
      };
    }

    const lockinMonths = 6;

    const penaltyPercentage =
      Number(selectedAccount?.scheme?.closureChargeBeforeValue) || 0;

    const annualROI = Number(selectedAccount?.scheme?.roi) || 0;

    const openingDate = new Date(selectedAccount?.openingDate);

    const transactionDate = formData.transactionDate
      ? new Date(formData.transactionDate)
      : new Date();

    const diffTime = transactionDate.getTime() - openingDate.getTime();

    const diffMonths = diffTime / (1000 * 60 * 60 * 24 * 30.44);

    let net = amount;
    let charge = 0;
    let interest = 0;
    let status = "";
    let message = "";

    // LESS THAN 6 MONTHS

    if (diffMonths < 6) {
      charge = (amount * penaltyPercentage) / 100;
      net = amount - charge;
      status = "PENALTY";
      message = `⚠️ Early withdrawal detected
Account age: ${diffMonths.toFixed(1)} months
Penalty: ${penaltyPercentage}%
Deduction: ₹${charge.toFixed(2)}
Final payout: ₹${net.toFixed(2)}`;
    }

    // 6 TO 12
    else if (diffMonths >= 6 && diffMonths < 12) {
      net = amount;
      status = "NO_INTEREST";
      message = `ℹ️ Account age: ${diffMonths.toFixed(1)} months
No penalty applied
No interest applicable
Principal amount only
Payout: ₹${net.toFixed(2)}`;
    }

    // 12+
    else {
      const years = diffMonths / 12;
      interest = (amount * annualROI * years) / 100;
      net = amount + interest;
      status = "WITH_INTEREST";
      message = `✅ Matured account
Account age: ${diffMonths.toFixed(1)} months
Interest: ${annualROI}%
Interest earned: ₹${interest.toFixed(2)}
Final payout: ₹${net.toFixed(2)}`;
    }

    return {
      net,
      charge,
      interest,
      status,

      percentage: status === "PENALTY" ? penaltyPercentage : annualROI,

      diffMonths: diffMonths.toFixed(1),

      lockinMonths,

      ruleMessage: message,
    };
  };

  const {
    net,
    charge,
    interest,
    status,
    diffMonths,
    percentage,
    lockinMonths: currentLockin,
    ruleMessage,
  } = calculateNetWithdrawal();

  const calculateMonthDifference = () => {
    if (!selectedAccount?.openingDate) return 0;

    const openingDate = new Date(selectedAccount.openingDate);

    const currentDate = new Date();

    const diffTime = currentDate - openingDate;

    const diffMonths = diffTime / (1000 * 60 * 60 * 24 * 30.44);

    return diffMonths > 0 ? diffMonths.toFixed(1) : 0;
  };

  const handlePreview = (e) => {
    e.preventDefault();

    if (!selectedAccount) {
      return toast.warn("Please select RD/DD account");
    }

    if (!formData.transactionType) {
      return toast.warn("Select transaction type");
    }

    if (!formData.amount || Number(formData.amount) <= 0) {
      return toast.warn("Enter valid amount");
    }

    if (!formData.transactionDate) {
      return toast.warn("Select transaction date");
    }

    if (
      new Date(formData.transactionDate) <
      new Date(selectedAccount?.openingDate)
    ) {
      return toast.warn("Transaction date cannot be before opening date");
    }

    if (
      Number(formData.amount) > Number(selectedAccount?.totalDeposited || 0)
    ) {
      return toast.warn("Withdrawal exceeds available balance");
    }

    setShowPreview(true);
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        accountId: selectedAccount?.id,
        withdrawAmount: Number(net),
        withdrawMode: formData.paymentMode,
        remarks: formData.narration,
        withdrawnBy: localStorage.getItem("userId"),
      };

      const res = await axios.post(`${API_URL}/deposit/pay/withdraw`, payload);

      toast.success(res?.data?.message || "Transaction successful");

      setFormData({
        amount: "",
        transactionType: "",
        paymentMode: "CASH",
        transactionDate: "",
        narration: "",
      });

      setSelectedAccount(null);
      setShowPreview(false);

      fetchAccounts();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Transaction failed");
    }
  };

  useEffect(() => {
    const fetchKyc = async () => {
      if (!selectedAccount?.customerId) return;

      try {
        const res = await axios.get(`${API_URL}/list-kyc`, {
          params: {
            userId: selectedAccount.customerId,
            createdId: profile?.id,
          },
        });

        setUploadedKyc(res?.data?.documents || []);
      } catch {
        setUploadedKyc([]);
      }
    };

    fetchKyc();
  }, [selectedAccount, profile?.id]);

  return (
    <div className="saving-account-transaction-container">
      <h2>RD DD Transaction Portal</h2>

      <div
        style={{
          background: "#f0f7ff",
          border: "1px solid #007bff",
          padding: "15px",
          borderRadius: "8px",
          marginBottom: "20px",
          fontSize: "0.9rem",
        }}
      >
        <h5
          style={{
            margin: "0 0 10px 0",
            color: "#0056b3",
          }}
        >
          📌 Settlement Rules for Scheme {selectedAccount?.schemeName || "N/A"}
        </h5>

        <ul
          style={{
            margin: 0,
            paddingLeft: "20px",
            color: "#333",
          }}
        >
          <li>
            <b>Early (0-6 Months):</b>{" "}
            {selectedAccount?.scheme?.closureChargeBeforeValue || 0}% Penalty
            applies
          </li>

          <li>
            <b>Standard (6-12 Months):</b> Principal payout only (No Interest)
          </li>

          <li>
            <b>Matured (12+ Months):</b> Principal +{" "}
            {selectedAccount?.scheme?.roi || 0}% ROI per annum
          </li>
        </ul>
      </div>

      <form
        className="saving-account-transaction-payment-details"
        onSubmit={handlePreview}
      >
        <h4>
          <i className="fa-solid fa-shield-halved"></i> Payment Details
        </h4>

        <div className="payment-details-container">
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>RD/DD Account</label>
              <Select
                className="account-select-container"
                classNamePrefix="account-select"
                placeholder="Search by Name or A/C No..."
                options={accounts.map((acc) => ({
                  value: acc.id,
                  label: `${acc.customerName} | ${acc.accountNo}`,
                  account: acc,
                }))}
                value={
                  selectedAccount
                    ? {
                        value: selectedAccount.id,
                        label: `${selectedAccount.customerName} | ${selectedAccount.accountNo}`,
                      }
                    : null
                }
                onChange={(selected) => setSelectedAccount(selected?.account)}
                isSearchable
              />
            </div>
            <div className="payment-details-inputs">
              <label>Available Balance</label>
              <input
                type="text"
                value={`₹ ${selectedAccount?.totalDeposited || "0.00"}`}
                readOnly
              />
            </div>
          </div>

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Amount (INR)</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                placeholder="0.00"
              />
            </div>
            <div className="payment-details-inputs">
              <label>Transaction Type</label>
              <select
                name="transactionType"
                value={formData.transactionType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                {/* <option value="DEPOSIT">DEPOSIT</option> */}
                <option value="WITHDRAWAL">WITHDRAWAL</option>
              </select>
            </div>
          </div>

          {status === "PENALTY" && (
            <div className="payment-details-input-groups">
              <div className="payment-details-inputs">
                <label>Early Withdrawal Charge (%)</label>

                <input type="text" value={`${percentage}%`} readOnly />
              </div>

              <div className="payment-details-inputs">
                <label>Penalty Amount</label>

                <input
                  type="text"
                  value={`₹ ${Number(charge || 0).toFixed(2)}`}
                  readOnly
                />
              </div>
            </div>
          )}

          {status === "WITH_INTEREST" && (
            <div className="payment-details-input-groups">
              <div className="payment-details-inputs">
                <label>Interest Rate</label>

                <input type="text" value={`${percentage}%`} readOnly />
              </div>

              <div className="payment-details-inputs">
                <label>Interest Earned</label>

                <input
                  type="text"
                  value={`₹ ${Number(interest || 0).toFixed(2)}`}
                  readOnly
                />
              </div>
            </div>
          )}

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Account Opening Date</label>
              <input
                type="text"
                value={
                  selectedAccount?.openingDate
                    ? new Date(selectedAccount.openingDate).toLocaleDateString(
                        "en-IN",
                      )
                    : ""
                }
                readOnly
              />
            </div>
            <div className="payment-details-inputs">
              <label>Account Tenure (Months)</label>
              <input
                type="text"
                value={
                  selectedAccount?.openingDate
                    ? `${calculateMonthDifference()} months`
                    : "0 months"
                }
                readOnly
              />
            </div>
          </div>

          {formData.transactionType === "WITHDRAWAL" && selectedAccount && (
            <div
              style={{
                marginTop: "15px",
                padding: "14px",
                borderRadius: "10px",
                whiteSpace: "pre-line",
                lineHeight: "1.8",
                fontSize: "14px",
                fontWeight: "500",
                background:
                  status === "PENALTY"
                    ? "#fff5f5"
                    : status === "NO_INTEREST"
                      ? "#fff9db"
                      : "#f0fff4",
                color:
                  status === "PENALTY"
                    ? "#c53030"
                    : status === "NO_INTEREST"
                      ? "#856404"
                      : "#2f855a",
                border: `1px solid ${
                  status === "PENALTY"
                    ? "#feb2b2"
                    : status === "NO_INTEREST"
                      ? "#ffeeba"
                      : "#c6f6d5"
                }`,
              }}
            >
              {ruleMessage}
            </div>
          )}
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Payment Mode</label>
              <select
                name="paymentMode"
                value={formData.paymentMode}
                onChange={handleChange}
              >
                <option value="CASH">CASH</option>
                <option value="UPI">UPI</option>
                <option value="RTGS">NEFT RTGS</option>
              </select>
            </div>
            <div className="payment-details-inputs">
              <label>Transaction Date</label>
              <input
                type="date"
                name="transactionDate"
                value={formData.transactionDate}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="payment-details-input-groups">
          <div className="payment-details-inputs">
            <label>Narration</label>
            <input
              type="text"
              name="narration"
              value={formData.narration}
              onChange={handleChange}
              placeholder="Optional narration"
            />
          </div>
        </div>

        <div className="kyc-section-title">Verified Documents</div>
        <div className="kyc-cards-container">
          {uploadedKyc.length === 0 ? (
            <p className="no-kyc">No KYC documents found for this account</p>
          ) : (
            uploadedKyc.map((doc, index) => (
              <div className="kyc-card" key={index}>
                <img
                  src={`https://payyug.in/uploads/${doc.docImage}`}
                  alt="KYC"
                  className="kyc-image"
                  onClick={() =>
                    window.open(
                      `https://payyug.in/uploads/${doc.docImage}`,
                      "_blank",
                    )
                  }
                />
                <p className="doctitle">{doc.docName || "Document"}</p>
              </div>
            ))
          )}
        </div>

        {selectedAccount && (
          <div className="bank-data-section">
            <h3 className="bank-data-title">Bank Details</h3>
            <div className="bank-data-grid">
              <div className="bank-data-item">
                <span className="bank-data-label">Account Number</span>
                <span className="bank-data-value">
                  {bankDetails?.bankAccount || "N/A"}
                </span>
              </div>
              <div className="bank-data-item">
                <span className="bank-data-label">Bank Name</span>
                <span className="bank-data-value">
                  {bankDetails?.bankName || "N/A"}
                </span>
              </div>
              <div className="bank-data-item">
                <span className="bank-data-label">IFSC Code</span>
                <span className="bank-data-value">
                  {bankDetails?.bankIfsc || "N/A"}
                </span>
              </div>
              <div className="bank-data-item">
                <span className="bank-data-label">Branch</span>
                <span className="bank-data-value">
                  {bankDetails?.bankBranch || "N/A"}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="pay-btn">
          <button type="submit">Verify & Process Transaction</button>
        </div>
      </form>

      {/* ================= PREVIEW MODAL ================= */}
      {/* {showPreview && (
        <div className="modal-overlay">
          <div className="transaction-modal">
            <h3>Confirm Transaction</h3>
            <div className="modal-content">
              <div className="modal-row"><span>Account:</span> <strong>{selectedAccount.customerName}</strong></div>
              <div className="modal-row"><span>A/C Number:</span> <strong>{selectedAccount.accountNo}</strong></div>
              <div className="modal-row"><span>Type:</span> <strong className={formData.transactionType}>{formData.transactionType}</strong></div>
              <div className="modal-row amount-row"><span>Amount:</span> <strong>₹ {formData.amount}</strong></div>
            </div>
            <div className="modal-actions">
              <button className="cancel-btn" onClick={() => setShowPreview(false)}>Edit</button>
              <button className="confirm-btn" onClick={handleSubmit}>Confirm Payment</button>
            </div>
          </div>
        </div>
      )} */}
      {showPreview && (
        <div className="modal-overlay">
          <div
            className="transaction-modal"
            style={{
              borderTop: `5px solid ${status === "PENALTY" ? "red" : "green"}`,
            }}
          >
            <h3 style={{ textAlign: "center" }}>Withdrawal Summary</h3>

            <div className="modal-content">
              <div className="modal-row">
                <span>Account No:</span>{" "}
                <strong>{selectedAccount.accountNo}</strong>
              </div>
              <div className="modal-row">
                <span>Tenure Completed:</span>{" "}
                <strong>{diffMonths} Months</strong>
              </div>

              <hr />

              <div className="modal-row">
                <span>Principal Amount:</span>
                <strong>
                  ₹ {Number(formData.amount).toLocaleString("en-IN")}
                </strong>
              </div>

              {status === "PENALTY" && (
                <div className="modal-row" style={{ color: "red" }}>
                  <span>Early Closure Penalty ({percentage}%):</span>
                  <strong>- ₹ {charge.toFixed(2)}</strong>
                </div>
              )}

              {status === "WITH_INTEREST" && (
                <div className="modal-row" style={{ color: "green" }}>
                  <span>Interest Earned ({percentage}%):</span>
                  <strong>+ ₹ {interest.toFixed(2)}</strong>
                </div>
              )}

              {status === "NO_INTEREST" && (
                <div
                  style={{
                    background: "#fff3cd",
                    padding: "8px",
                    borderRadius: "4px",
                    fontSize: "0.8rem",
                    textAlign: "center",
                    marginBottom: "10px",
                  }}
                >
                  ℹ️ No interest or penalty is applicable between 6–12 months.
                </div>
              )}

              <div
                className="modal-row amount-row"
                style={{
                  background: "#f8f9fa",
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                <span style={{ fontSize: "1.1rem" }}>Final Payout:</span>
                <strong style={{ fontSize: "1.5rem", color: "#000" }}>
                  ₹ {net.toFixed(2)}
                </strong>
              </div>
            </div>

            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowPreview(false)}
              >
                Modify
              </button>
              <button
                className="confirm-btn"
                onClick={handleSubmit}
                style={{
                  background: status === "PENALTY" ? "#dc3545" : "#28a745",
                }}
              >
                Confirm & Process
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RDDDAccountTransaction;
